<template>
  <div class="menu_box">
    <div class="menu_title">2025世界口腔医学大会-展览会</div>
    <el-menu
      ref="menu"
      text-color="#666"
      background-color="#eee"
      class="el-menu-middle"
      mode="vertical"
      :menu-trigger="'click'"
      :unique-opened="true"
      @select="handleSelect"
    >
      <el-menu-item
        v-for="(item, index) in menuArr"
        :key="index"
        :index="langSet == 'cn' ? item.http_url_cn : item.http_url_en"
      >
        <el-submenu
          popper-class="test"
          v-if="item.children"
          :index="langSet == 'cn' ? item.http_url_cn : item.http_url_en"
          :key="index"
          :show-timeout="100"
        >
          <template slot="title">
            <span>{{ langSet == "cn" ? item.name_cn : item.name_en }}</span>
          </template>
          <el-menu-item
            v-for="(n, i) in item.children"
            :key="i"
            :index="
              langSet == 'cn'
                ? n.http_url_cn !== '/download'
                  ? n.http_url_cn
                  : n.http_url_cn + '/' + n.id
                : n.http_url_en !== '/download'
                ? n.http_url_en
                : n.http_url_en + '/' + n.id
            "
          >
            <template>
              <span slot="title">{{
                langSet == "cn" ? n.name_cn : n.name_en
              }}</span>
            </template>
          </el-menu-item>
        </el-submenu>
        <!-- 没有子菜单 -->
        <el-menu-item
          v-else
          :index="langSet == 'cn' ? item.http_url_cn : item.http_url_en"
          :key="index"
        >
          <span slot="title">{{
            langSet == "cn" ? item.name_cn : item.name_en
          }}</span>
        </el-menu-item>
        <!-- <span>{{ langSet == "cn" ? item.name_cn : item.name_en }}</span> -->
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import router from "../router/index.js";
import { webMenu } from "@/api/api";
export default {
  data() {
    return {
      menuArr: [],
    };
  },
  created() {
  },
  mounted() {
    // this.navDefalut();
    this.getMenu();
    this.langSet = this.$language;
  },
  computed: {},
  methods: {
    startsWithSlash(str) {
      return /^\//.test(str);
    },
    handleSelect(key, keyPath) {
      if (this.$route.fullPath === key) {
        this.$emit("closeMenu");
      }
      if (keyPath.length == 1) {
        return false;
      }
      if (key) {
        if (this.startsWithSlash(key)) {
          this.$router.push({
            path: key,
          });
        } else {
          let path = window.location.protocol + "//" + key;
          window.open(path, "_blank");
        }
      }
    },
    getMenu() {
      let arr = [];
      let data = {
        page_type: 0,
      };
      webMenu(data)
        .then((res) => {
          if (res.code == 1) {
            let lists = res.data.lists;
            lists.map((item, index) => {
              if (item.is_top == "是") {
                arr.push(item);
              }
            });
            console.log(arr, "===arr");
            arr = [
              ...arr,
              {
                name_cn: "个人主页",
                name_en: "Homepage",
                http_url_cn: "/personal",
                http_url_en: "/personal",
                type: "内部跳转",
                children: [
                  {
                    name_cn: "个人资料",
                    name_en: "Personal Information",
                    http_url_cn: "/personal",
                    http_url_en: "/personal",
                  },
                  {
                    name_cn: "我的收藏",
                    name_en: "My Collection",
                    http_url_cn: "/mycollect",
                    http_url_en: "/mycollect",
                  },
                  {
                    name_cn: "我的商机",
                    name_en: "My Business",
                    http_url_cn: "/mybusiness",
                    http_url_en: "/mybusiness",
                  },
                ],
              },
            ];
            this.menuArr = arr;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.menu_box {
  background: #eee;
  .menu_title {
    color: #666;
    font-size: 14px;
    line-height: 40px;
    margin-left: 0.34rem;
    border-bottom: 1px #ddd solid;
  }
}
.el-menu {
  height: 80vh;
  padding: 0 0 0 0.34rem;
  box-sizing: border-box;
}
.el-menu-item {
  border-bottom: 1px solid #ddd;
  font-size: 14px;
  line-height: 40px;
  padding: 0 !important;
  height: auto;
}
/deep/ .el-submenu__title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding-left: 0 !important;
  background: #eee !important;
}
/deep/ .el-submenu__title span {
  width: 94%;
  margin: 10px 0;
  height: 20px;
  line-height: 20px;
  display: inline-block;
  border-right: 1px solid #ddd;
}
.el-menu-item:last-child {
  border-bottom: 0;
}
.menu_box {
  width: 100%;
  z-index: 10;
}
/deep/ .el-submenu {
  padding-right: 0;
  display: block;
}
/deep/ .el-submenu .el-menu {
  border-top: 1px solid #ddd;
  padding-left: 20px;
}
/deep/ .el-submenu .el-menu-item {
  color: #999 !important;
  background: #eee !important;
}
/deep/ .el-menu-middle > .el-menu-item:last-child {
  border-bottom: 1px solid #ddd;
}
/deep/ .el-submenu__icon-arrow {
  right: 10px;
  font-size: 16px;
  color: #555 !important;
  font-weight: bold;
}
/deep/ .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  color: #c9141e !important;
}
</style>